import { useState } from 'react';
import { MemberAdditionalDocumentClient, MemberAdditionalDocumentDTO, ApiResponse_string, SearchRequestDTO_MemberAdditionalDocumentSearchRequestDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useMemberAdditionalDocumentApi = () => {
    const apiClient = new MemberAdditionalDocumentClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: MemberAdditionalDocumentDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createMemberAdditionalDocument(data);
        } catch (err: any) {
            setError(err.message || 'Error creating MemberAdditionalDocument');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: MemberAdditionalDocumentDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateMemberAdditionalDocument(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating MemberAdditionalDocument');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getMemberAdditionalDocumentById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching MemberAdditionalDocument');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchMemberAdditionalDocuments(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching MemberAdditionalDocuments');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteMemberAdditionalDocument(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting MemberAdditionalDocument');
        } finally {
            setIsLoading(false);
        }
    };

    const extract = async (
        filters: any
    ): Promise<ApiResponse_string> => {
        setIsLoading(true);
        try {
            return await apiClient.exportMemberAdditionalDocuments(filters);
        } catch (err: unknown) {
            handleHookError(err, 'Error exporting MemberAdditionalDocuments', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, extract, remove, isLoading, error };
};